import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const DetectNetworkStatus = ({ children }) => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      fetch('https://api-carcheck.autobiz.com/', {
        mode: 'no-cors',
      })
        .then(() => !isOnline && setIsOnline(true))
        .catch(() => isOnline && setIsOnline(false));
    }, 10000);

    return () => clearInterval(interval);
  });

  return <>{!isOnline && children}</>;
};

DetectNetworkStatus.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DetectNetworkStatus;
